export class Step1 {
    constructor() {}

    intitule = 'stepper.form.dive_re.step1';
    
    getnumannonce = 'form.dive_at.getnumannonce';
    getidweb = 'form.dive_at.getidweb';
    getdatepublication = 'form.dive_at.getdatepublication';
    getdatepublicationjoce = 'form.dive_at.getdatepublicationjoce';

}
